module.exports = __webpack_public_path__ + "static/media/red-alert.ea1c8e50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/red-alert.svg
// module id = 329
// module chunks = 1